import React, { PureComponent, useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { Player, Comment } from 'ThreeTerminal_pc_dynamic';
import Ad from '@ifeng/ui_pc_ad';
import { Share } from '@ifeng/ui_pc_share';
import HeaderNav from '../../components/header';
import Banner from './banner';
import Footer from '../../components/footer/';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './index.css';
import { nav, footer, banner } from './assets/data';

const pickContent = (props, name) => {
    const { content } = props;
    let result = [];

    content.modules.forEach(item => {
        if (name === item.title) result = item.data.articleList;
    });

    result.forEach(item => {
        item.thumbnail = item.thumbnail || (item.thumbnails?.image && item.thumbnails?.image[0]?.url);
    });

    return result;
};

const Header = errorBoundary(props => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [videoPlay, setVideoPlay] = useState(true);
    const banner = pickContent(props, 'banner');
    const videos = pickContent(props, '右侧视频栏');

    const changeVideo = index => {
        setVideoPlay(false);
        setActiveIndex(index);
    };

    useEffect(
        () => {
            setVideoPlay(true);
        },
        [activeIndex],
    );

    return (
        <div className={styles.header} style={{ backgroundImage: `url(${banner[3].thumbnail})` }}>
            <div
                className={styles.ad}
                onClick={() => {
                    if (banner[0].url) location.href = banner[0].url;
                }}>
                <img src={banner[0].thumbnail} alt="" />
            </div>
            <div className={styles.header_innner}>
                <div className={styles.header_title}>
                    <img src={banner[1].thumbnail} alt="" />
                    <div style={{ color: banner[4].url }}>{banner[2].title}</div>
                </div>
                <div className={styles.header_video}>
                    <div className={styles.header_video_content}>
                        {videoPlay ? (
                            <Player
                                videoConfig={{
                                    videoLargePoster: videos[activeIndex].thumbnail,
                                    videoPlayUrl: videos[activeIndex].url,
                                }}
                                playermsg={{
                                    width: 720,
                                    height: 424,
                                    isAuth: 'auth',
                                    autoPlay: false,
                                    subject: props.content.base62Id,
                                }}
                            />
                        ) : null}
                    </div>
                    <div className={styles.header_video_menu}>
                        {videos.map((item, index) => {
                            return (
                                <div
                                    key={index}
                                    onClick={() => changeVideo(index)}
                                    className={`${styles.header_video_menu_item} ${
                                        index === activeIndex ? styles.header_video_menu_item_active : null
                                    }`}>
                                    {item.title}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
});

const ViewPoint = errorBoundary(props => {
    const pointDes = pickContent(props, '精彩观点摘要栏');
    const points = pickContent(props, '精彩观点内容');
    const ad = pickContent(props, '广告栏');

    return (
        <div className={styles.viewPoint}>
            <div className={styles.ad}>
                <Ad
                    content={{
                        data: {
                            title: '广告',
                            aids: [
                                {
                                    ap: '33393',
                                    w: '1000',
                                    h: '90',
                                    res: '1',
                                },
                            ],
                        },
                        preload: 'https://c0.ifengimg.com/iis/iis_v3_0.js',
                        callback: 'function(elm, data) {IfengAmgr.show(elm,data);}',
                    }}
                    styleName={styles.ad}
                />
                {/* <img src={ad[0].thumbnail} onClick={() => window.open(ad[0].url, '_blank')} alt="" /> */}
            </div>
            <div className={styles.block_title}>精彩观点</div>
            <div className={styles.viewPoint_content}>
                {points.map((item, index) => (
                    <div key={index} className={styles.viewPoint_item}>
                        <img src={item.thumbnail} alt="" />
                        <div className={styles.viewPoint_item_right}>
                            <div>{item.title}</div>
                            <div>
                                {pointDes[index].title}
                                <span onClick={() => (location.href = item.url)}>[详细]</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
});

const Review = errorBoundary(props => {
    const slide = useRef(null);
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        className: styles.reviewSlide,
    };
    const reviews = pickContent(props, '往期回顾');
    const formateData = [];

    reviews
        .slice()
        .reverse()
        .forEach((item, index) => {
            const key = parseInt(index / 6);

            item.num = reviews.length - index < 10 ? `0${reviews.length - index}` : reviews.length - index;

            formateData[key] = formateData[key] || [];
            formateData[key].push(item);
        });

    const [showList, setShowList] = useState(false);

    return (
        <div className={styles.review}>
            <div className={styles.block_title}>往期回顾</div>
            <div className={styles.other} onClick={() => setShowList(!showList)}>
                <div className={styles.other_title}>
                    <img src="//p3.ifengimg.com/l/2018/33/70e17e4765dd9c2/top_list.png" alt="" />前行者往期精彩系列
                </div>
                {showList ? (
                    <div className={styles.other_list}>
                        {reviews
                            .slice()
                            .reverse()
                            .map((item, index) => {
                                return (
                                    <div onClick={() => window.open(item.url, '_blank')} key={index}>
                                        {item.title}
                                    </div>
                                );
                            })}
                    </div>
                ) : null}
            </div>
            <img
                className={styles.slidePre}
                src={'http://p0.ifengimg.com/fe/former_traveler/images/left_arrow_b2c6c972.jpg'}
                onClick={() => {
                    slide.current.slickPrev();
                }}
            />
            <img
                className={styles.slideNext}
                src={'http://p0.ifengimg.com/fe/former_traveler/images/right_arrow_fd123880.jpg'}
                onClick={() => slide.current.slickNext()}
            />
            <Slider {...settings} ref={slider => (slide.current = slider)}>
                {formateData.map((item, _index) => {
                    return (
                        <div key={_index} className={styles.review_item}>
                            {item.map((card, index) => {
                                return (
                                    <div
                                        key={index}
                                        className={styles.review_card}
                                        onClick={() => window.open(card.url, '_blank')}>
                                        <img src={card.thumbnail} alt="" />
                                        <div>
                                            <div>
                                                {card.num}
                                                <span>期</span>
                                            </div>
                                            <a target="_blank" href={card.url}>
                                                {card.title}
                                            </a>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </Slider>
        </div>
    );
});

const BigImg = errorBoundary(props => {
    const slide = useRef(null);
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        className: styles.reviewSlide,
    };
    const dataDes = pickContent(props, '高清大图摘要');
    const data = pickContent(props, '高清大图');

    return (
        <div className={styles.bigimg}>
            <div className={styles.block_title}>高清大图</div>
            <img
                className={styles.slidePre}
                src={'//x0.ifengimg.com/cmpp/37780e23b9ea2d8b/2019/42/left_arrow.png'}
                onClick={() => {
                    slide.current.slickPrev();
                }}
            />
            <img
                className={styles.slideNext}
                src={'//x0.ifengimg.com/cmpp/37780e23b9ea2d8b/2019/42/right_arrow.png'}
                onClick={() => slide.current.slickNext()}
            />
            <Slider {...settings} ref={slider => (slide.current = slider)}>
                {data.map((item, index) => {
                    return (
                        <div key={index} className={styles.bigimg_item} onClick={() => window.open(item.url, '_blank')}>
                            <img src={item.thumbnail} alt="" />
                            <div className={styles.bigimg_item_intro}>
                                <div>
                                    <div>{index + 1}</div>
                                    <div>{data.length}</div>
                                </div>
                                <div>
                                    <div>{item.title}</div>
                                    <div>{dataDes[index] && dataDes[index].title}</div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </Slider>
        </div>
    );
});

const CommentCopm = errorBoundary(props => {
    const { content } = props;
    const comment = content.modules.filter(item => {
        return item.type === 'comment';
    })[0];

    const commentConfig = {
        docUrl: `ucms_${content.base62Id}`, // 文章单页的页面地址
        docTitle: '', // 文章的标题
        skey: '', // 文章评论的skey，这个是在后端生成好后给到前端的
        speUrl: '', // 兼容以后的专题评论
        pcUrl: 'https://news.ifeng.com/c/7qcihapDpPU', // 文章pc的页面地址
        // 获取评论内容接口
        cmtNumUrl: '//comment.ifeng.com/get.php',
        // 评论内容字数长度
        cmtLength: 1000,
        // 提交评论内容接口
        cmtPostUrl: '//comment.ifeng.com/post.php',
        // 最热评论数量
        hotLimit: 2,
        // 推荐评论接口
        cmtVoteUrl: '//comment.ifeng.com/vote.php',
        // 现实回复的楼层
        replyLimit: 3,
        // 举报提交接口
        jubUrl: '//comment.ifeng.com/report',
        // 举报次数，便于每次回调函数名不同
        jubNum: 0,
        // 是否是评论详情页面
        isComment: true,
        // 是否允许评论
        allowComment: true,
        // 'uptimes' 按热度排序，'create_time' 按时间排序， 'both', 两者同时存在
        order: 'both',
        options: 1, // 0 先显示最新，后显示最热，1 反之，此配置在 order 是 both 的情况下才生效
        recentLimit: 20, // 最近评论数量
        recentReplyLimit: 3, // 最近评论数量显示回复的楼层
        showEmptyCommentTip: true, // 是否显示空评论时提示
        usePagination: true, // 是否使用分页
        // showTempComment: true, // 是否显示即发即显评论
        // hasIntervalBannerAd: true, // 是否有间隔通栏广告
        // intervalBannerAdData: {
        //     data: { aids: [{ ap: '23942', w: '640', h: '90', res: '1' }] },
        //     preload: '',
        //     callback: 'function(elm, data) {IfengAmgr.show(elm,data);}',
        // }, // 间隔通栏广告数据
        // intervalBannerAdStyle: styles.intervalBannerAd, // 间隔通栏广告自定义样式
    };

    return (
        <div className={styles.comment}>
            <div className={styles.block_title}>网友评论</div>
            <Comment articleInfo={commentConfig} />
        </div>
    );
});

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const intro = pickContent(this.props, '栏目介绍');
        const share = pickContent(this.props, '分享');

        return (
            <div className={styles.container}>
                <HeaderNav limit={18} content={nav.content} />
                <Banner content={banner} />
                <Header content={content} />
                <ViewPoint content={content} />
                <Review content={content} />
                <BigImg content={content} />
                <CommentCopm content={content} />
                <div className={styles.share}>
                    <Share
                        config={{
                            items: ['sina', 'wechat', 'cof', 'qqzone'],
                            display: 'normal',
                            hover: 'hover',
                            type: 'vertical',
                            methods: 'hover',
                            tooltip: 'top',
                        }}
                        shareInfo={{
                            url: encodeURI(share[0].url),
                            title: share[0].title,
                            summery: share[1].url,
                            picUrl:
                                share[2].url || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
                        }}
                    />
                </div>
                <div className={styles.intro}>
                    <div>
                        <div>栏目介绍</div>
                        <div>{intro[0].title}</div>
                    </div>
                    <div>
                        <div>联系方式</div>
                        <p>出品：凤凰网财经</p>
                        <p>邮箱：all_finance@ifeng.com</p>
                        <p>邮编：100120</p>
                        <p>地址：北京市朝阳区望京启阳路4号中轻大厦16层</p>
                    </div>
                </div>
                <Footer content={footer.content} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
